/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'filter': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g _stroke="#00272E"><path pid="0" d="M22.999 9.517a.497.497 0 00-.125-.363.46.46 0 00-.341-.154H9.467a.46.46 0 00-.34.154.496.496 0 00-.126.363c.225 3.256 2.512 5.957 5.595 6.61v6.388c0 .188.105.36.27.44.163.079.357.053.497-.067l1.87-1.617a.491.491 0 00.169-.373v-4.77c3.084-.652 5.372-3.354 5.597-6.61z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/filter.js